import { Component } from 'react';
import moment from 'moment-timezone';

export default class BaseDailyPage extends Component {
  componentWillMount() {
    if(!this.startDateFromUrl || !moment.unix(this.startDateFromUrl).isValid() || this.disabledDate(moment.unix(this.startDateFromUrl))) {
      this.setQueryParam('startDate', this.defaultDate);
    }
  }

  get revivalWeeks() {
    return this.props.revivalWeeks.church.revival.weeks;
  }

  get nowInChurchTimezone() {
    return moment().tz(this.props.selectedChurch.timezone);
  }

  get defaultDate() {
    return this.nowInChurchTimezone.clone().startOf('day').unix();
  }

  get periodStartDate() {
    return moment.unix(this.startDateFromUrl).tz(this.props.selectedChurch.timezone);
  }

  get periodEndDate() {
    return this.periodStartDate.endOf('day');
  }

  get dateFormat() {
    return "MMMM D, YYYY";
  }

  get startDateFromUrl() {
    const query = new URLSearchParams(this.props.history.location.search);
    return query.get('startDate');
  }

  setQueryParam(param, value) {
    const query = new URLSearchParams(this.props.history.location.search);
    query.set(param, value);
    this.props.history.push({ search: query.toString() });
  }

  disabledDate = (current) => {
    const startDate = moment.unix(this.revivalWeeks[0].startDate);
    const endDate = moment();
    return !current.isBetween(startDate, endDate, null, "[]");
  };

  onDayChange = (date, _dateString) => {
    this.setQueryParam('startDate', (date || this.nowInChurchTimezone).clone().startOf('day').unix());
  };
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/baseDailyPage.js